import { SegmentContextType } from 'common/types/segments';
import { useOutletContext } from 'react-router-dom';

export function useSegmentsOutletContext() {
  return useOutletContext<SegmentContextType>();
}
